import useLocalStorage from './useLocalStorage'

export default () => {
  const isOpen = ref<boolean>(true)
  const bannerLastCloseAt = useLocalStorage('bannerLastCloseAt', '')
  const shouldBeVisible = (lastUpdatedAt: string): boolean => {
    if (import.meta.client) {
      const lastClosedAt = bannerLastCloseAt.get()
      if (lastUpdatedAt && lastClosedAt) {
        return Date.parse(lastUpdatedAt) > parseInt(lastClosedAt)
      }
    }
    return true
  }
  const close = () => {
    if (import.meta.client) {
      const currentTime = Date.parse(new Date().toString())
      bannerLastCloseAt.set(currentTime.toString())
      isOpen.value = false
    }
  }

  return {
    close,
    isOpen,
    shouldBeVisible,
  }
}
